import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export function initHighlightsAnimation() {
  gsap.from(".highlight-card", {
    scrollTrigger: {
      trigger: ".hallmarks-track, .highlights-grid",
      start: "top 85%", // Triggers when top of grid hits 85% of viewport height
      toggleActions: "play none none none"
    },
    opacity: 0,
    y: 40,
    duration: 0.8,
    stagger: 0.15, // Sequential smooth wave entrance
    ease: "power3.out",
    clearProps: "opacity,transform"
  });
}
